import styled from 'styled-components';
import { IDividerProps } from '.';

export const Container = styled.div`
  width: ${(props: IDividerProps) => props.w};
  height: ${(props: IDividerProps) => props.h};

  border: 1px solid ${props => props.theme.colors.grey};
`;
